import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  Box,
  Divider,
  CircularProgress,
} from '@mui/material';
import { DateTime } from 'luxon';
import { ChevronLeft } from '@mui/icons-material';

// COMPONENTS
import SectionWrapper from '../../common/SectionWrapper';

// REQUEST
import useInboxRequest from '../../../requests/InboxRequest';

// MESSAGES
import InboxFormattedMessages from '../../../messages/websms/InboxFormattedMessages';

const InboxSingle = ({
  message,
  clickedReply,
  backButtonClick,
  errorHandler,
}) => {
  const [replyData, setReplyData] = useState(null);
  const { getInboxReply } = useInboxRequest();

  useEffect(() => {
    async function getData() {
      const replyId = message.isEmailReply
        ? message.email_reply_id
        : message.sms_reply_id;
      const isEmailReply = message.isEmailReply || false;
      const replyData = await getInboxReply(
        replyId,
        isEmailReply,
        errorHandler
      );
      setReplyData(replyData);
    }
    getData();
  }, [message]);

  if (!replyData)
    return (
      <SectionWrapper
        title={InboxFormattedMessages.smsInformation}
        icon="messages"
      >
        <CircularProgress />
      </SectionWrapper>
    );

  const decodeText = (text) => {
    try {
      return decodeURIComponent(text);
    } catch {
      return 'ERROR: MALFORMED TEXT';
    }
  };

  const childSmsText = decodeText(replyData.child_sms?.sms_text || '');
  const parentSmsText = decodeText(replyData.message || '');

  const formatDate = (isoString) =>
    DateTime.fromISO(isoString)
      .setZone(localStorage.getItem('timeShort'), { keepLocalTime: false })
      .toFormat('dd-LLL-yyyy h:mm:ss a');

  return (
    <SectionWrapper
      title={InboxFormattedMessages.smsInformation}
      icon="messages"
    >
      <Box>
        <Button
          startIcon={<ChevronLeft />}
          onClick={backButtonClick}
          color="secondary"
          sx={{ marginBottom: 2 }}
        >
          <Typography>{InboxFormattedMessages.backText}</Typography>
        </Button>
      </Box>

      <Typography variant="h3" gutterBottom>
        {InboxFormattedMessages.replyDetails}
      </Typography>

      <Box>
        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.tableHeaderDate}</strong>
          {`: ${formatDate(message.created_date)}`}
        </Typography>

        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.tableFrom}</strong>
          {`: ${message.dest_tn}`}
        </Typography>

        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.tableHeaderMessage}</strong>
          {`: ${childSmsText}`}
        </Typography>
      </Box>

      <Divider sx={{ marginY: 2 }} />

      <Typography variant="h3" gutterBottom>
        {InboxFormattedMessages.originalMessageDetails}
      </Typography>

      <Box>
        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.originalTime}</strong>
          {`: ${formatDate(message.sms_sent)}`}
        </Typography>

        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.originalSender}</strong>
          {`: ${replyData.from}`}
        </Typography>

        <Typography gutterBottom>
          <strong>{InboxFormattedMessages.originalMessage}</strong>
          {`: ${parentSmsText}`}
        </Typography>
      </Box>

      <Box>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => clickedReply(message)}
          sx={{ marginY: 2 }}
        >
          {InboxFormattedMessages.replyButton}
        </Button>
      </Box>
    </SectionWrapper>
  );
};

export default InboxSingle;
